import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';

const rechargeDoneSearchSchema = z.object({
  amount: z.number().optional(),
  transactionId: z.string().optional(),
  transactionTstamp: z.string().optional(),
  paymentType: z.string().or(z.number()).optional(),
  ext_customParams: z.string().optional(),
  charges: z.number().optional(),
});

export const Route = createFileRoute('/_auth/_layout_with_navbar/topup-done')({
  validateSearch: zodValidator(rechargeDoneSearchSchema),
});
